import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Global/Buttons/Button';
import IconWithText from '../Global/Icons/IconWithText';
import FavouriteButton from '../Global/Buttons/FavouriteButton';
import ReportButton from '../Global/Buttons/ReportButton';
import AddToFolderButton from '../Global/Buttons/AddToFolderButton';

const DrillActions = ({ loggedInUser, cmsCreated, printClick, favourited, favouriteClick, reported, reportClick, folderClick, exportImageClick, contentType }) => (
  <div className="drill-actions fw-medium">
    <ul>
      <li><Button onClick={printClick} faux><IconWithText name="print" size="m" fill="black">Print</IconWithText></Button></li>
      <li><FavouriteButton favourited={favourited} onClick={favouriteClick} loggedInUser={loggedInUser} /></li>
      {/* <li><button className="faux-btn"><IconWithText name="cone" size="m" fill="black">Add to Session</IconWithText></button></li> */}
      <li><AddToFolderButton onClick={folderClick} loggedInUser={loggedInUser} /></li>
      {contentType === 'pitchdiagram' &&
        <li><Button onClick={exportImageClick} faux><IconWithText name="download" size="m" fill="black">Export Image</IconWithText></Button></li>
      }
      {/* <li><button className="faux-btn"><IconWithText name="edit" size="m" fill="black">Duplicate & edit</IconWithText></button></li> */}
      {/* Hide the report content button if the content is created by TCM */}
      {/* {cmsCreated === false &&
        <li><ReportButton reported={reported} onClick={reportClick} /></li>
      } */}
    </ul>
  </div>
);

DrillActions.propTypes = {
  loggedInUser: PropTypes.object,
  cmsCreated: PropTypes.bool,
  printClick: PropTypes.func.isRequired,
  favourited: PropTypes.bool.isRequired,
  favouriteClick: PropTypes.func.isRequired,
  reported: PropTypes.bool,
  reportClick: PropTypes.func,
  folderClick: PropTypes.func,
  exportImageClick: PropTypes.func,
  contentType: PropTypes.string,
};

export default DrillActions;



// WEBPACK FOOTER //
// ./library/app/components/Drill/DrillActions.js